<script setup lang="ts">
import type { TooltipRootEmits, TooltipRootProps } from "reka-ui"
import { TooltipRoot, useForwardPropsEmits } from "reka-ui"
import TooltipProvider from "./TooltipProvider.vue"

const props = defineProps<TooltipRootProps>()
const emits = defineEmits<TooltipRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <!-- Own provider so the tooltip never crashes when mounted outside a
  TooltipProvider; an explicit delay-duration prop still wins over it. -->
  <TooltipProvider>
    <TooltipRoot
      data-slot="tooltip"
      v-bind="forwarded"
    >
      <slot />
    </TooltipRoot>
  </TooltipProvider>
</template>
